<template lang="pug">
v-dialog(v-model="dialog" max-width="600")
  v-card
    v-card-title Add New Language
    v-card-text
      v-row
        v-col(v-if="!firstPage" label="Name")
          v-select(v-model="form.locale" label="Language Code" :items="newLocales" item-text="name" item-value="id")
        v-col(cols="12")
          v-text-field(v-model="form.name" label="Name")
        v-col(cols="12")
          v-text-field(v-model="form.slug" label="URL Slug")
        v-col(cols="12")
          v-text-field(v-model="form.special" label="Special Tagline")
    v-card-actions
      v-btn(block large tile color="primary" @click="add") Add
</template>

<script>
export default {
  name: "NewContentDialog",
  props: ['value', 'firstPage', 'product', 'newLocales'],
  data: (vm) => ({
    dialog: vm.value,
    form: {
      product: null,
      locale: 1,
      name: '',
      slug: '',
      special: '',
      status: 'draft'
    }
  }),
  watch: {
    value (val) {
      this.dialog = val
    },
    dialog (val) {
      this.$emit('input', val)
    },
    product (val) {
      this.form.product = val.id
      this.form.name = val.original_title
      this.form.slug = val.original_title.replace(' ', '-').toLowerCase()
    }
  },
  methods: {
    add () {
      this.$axios.post('/contents/', this.form)
        .then(resp => {
          this.$emit('added', resp.data)
          this.dialog = false
          location.reload()
          this.$showAlert('success', 'New page language added!')
        })
        .catch(e => {
          this.$showAlert('error', 'Error adding new page!')
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>